import { toast } from "react-toastify";

export const showError = (message) => {
  return toast.error(message);
};

export const showSuccess = (message) => {
  return toast.success(message);
};
